import { render, staticRenderFns } from "./ExamsList.vue?vue&type=template&id=6511ce0a&"
import script from "./ExamsList.vue?vue&type=script&lang=js&"
export * from "./ExamsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports